<template>
  <div class="form-temp" v-if="isShow">
    <div class="form-temp-left">
      <i :class="`icon iconfont ${icon}`"></i>
      <toolTip class="title" :title="title"><span>{{title}}</span></toolTip>
    </div>
    <div class="form-temp-right">
      <slot></slot>
    </div>
  </div>
</template>
<script>
export default {
  props: ['title', 'icon', 'value', 'readonly'],
  computed: {
    isShow() {
      return Boolean((this.value && (Array.isArray(this.value) ? this.value.length > 0 : false)) || !this.readonly)
    }
  },
  watch: {
    value() {

    }
  },
  data() {
    return {

    }
  }
}
</script>

<style lang="scss">
@import "@/assets/scss/mixin.scss";
.form-temp {
  min-height: 40px;
  margin-top: 16px;
  display: flex;
  box-sizing: border-box;
  .form-temp-left {
    @include fontColorOpacity(.6);
    font-size: 14px;
    display: flex;
    align-items: center;
    width: 112px;
    flex-shrink: 0;
    // padding-top: 12px;
    display: flex;
    height: 40px;
    .title {
      flex: 1;
      width: 0;
    }
    i {
      font-size: 14px;
      margin-right: 9px;
      flex-grow: 0;
    }
  }
  .form-temp-right {
    display: flex;
    align-items: center;
    width: 0;
    flex: 1;
    .rest-form-item {
      width: 100%;
    }
    .readonly {
      @include fontColorOpacity(.6);
    }
    .rich-text {
      width: 100%;
    }
  }
}
</style>
